import { render, staticRenderFns } from "./ManualSetup.vue?vue&type=template&id=352155ec&"
import script from "./ManualSetup.vue?vue&type=script&lang=js&"
export * from "./ManualSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports